<template>
  <MenuContainer
    is-company
    :menu-items="menuItems"
    dashboardLink="/company-dashboard"
    notificationLink="/company-notifications"
    settingsLink="/company-notification-preferences"
    accountLink="/company-account">
    <template #banner>
      <CompanyBanners/>
    </template>
    <template #default>
      <slot/>
    </template>
  </MenuContainer>
</template>

<script setup>
import MenuContainer from "../components/MenuContainer.vue";
import {
  BriefcaseIcon,
  BuildingOfficeIcon,
  CalendarDaysIcon,
  ChartBarIcon,
  ChatBubbleOvalLeftEllipsisIcon,
  ClipboardDocumentListIcon,
  HomeIcon,
  UsersIcon,
} from "@heroicons/vue/24/outline";
import {
  BriefcaseIcon as BriefcaseIconSolid,
  BuildingOfficeIcon as BuildingOfficeIconSolid,
  CalendarDaysIcon as CalendarDaysIconSolid,
  ChartBarIcon as ChartBarIconSolid,
  ChatBubbleOvalLeftEllipsisIcon as ChatBubbleOvalLeftEllipsisIconSolid,
  ClipboardDocumentListIcon as ClipboardDocumentListIconSolid,
  HomeIcon as HomeIconSolid,
  UsersIcon as UsersIconSolid,
} from "@heroicons/vue/24/solid";
import CompanyBanners from "../components/CompanyBanners.vue";
import { computed } from "vue";
import { usePilotFlag } from "../composables/UsePilotFlag";
import { COMPANY_ANALYTICS } from "../constants/PilotFlags";

const { isEnabled: hasCompanyAnalytics } = usePilotFlag(COMPANY_ANALYTICS);

const menuItems = computed(() => {
  const items = [
    {
      name: "Dashboard",
      link: "/company-dashboard",
      icon: HomeIcon,
      iconSolid: HomeIconSolid,
    },
    {
      name: "Opportunities",
      link: "/company-opportunities",
      icon: BriefcaseIcon,
      iconSolid: BriefcaseIconSolid,
    },
    {
      name: "Candidates",
      link: "/company-candidates",
      icon: UsersIcon,
      iconSolid: UsersIconSolid,
    },
    {
      name: "Interviews",
      link: "/company-interviews",
      icon: CalendarDaysIcon,
      iconSolid: CalendarDaysIconSolid,
    },
    {
      name: "My Tasks",
      link: "/company-tasks",
      icon: ClipboardDocumentListIcon,
      iconSolid: ClipboardDocumentListIconSolid,
    },
    {
      name: "Messages",
      link: "/company-messages",
      icon: ChatBubbleOvalLeftEllipsisIcon,
      iconSolid: ChatBubbleOvalLeftEllipsisIconSolid,
    },
  ];

  if (hasCompanyAnalytics.value) {
    items.push({
      name: "Analytics",
      link: "/company-analytics",
      icon: ChartBarIcon,
      iconSolid: ChartBarIconSolid,
    });
  }

  items.push({
    name: "Company",
    link: "/company-profile",
    icon: BuildingOfficeIcon,
    iconSolid: BuildingOfficeIconSolid,
  });

  return items;
});
</script>
